import { Box, Typography, IconButton } from "@mui/material";
import React, { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import uploadbutton from "../../assets/images/uploadbutton.svg";
import { getFileIcon } from "../../utils/getFileIcon";

const FileRead = ({ handleChange, setFile, name, errors }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [file, setFileState] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    setFileState(selectedFile);
  };

  const handleDeleteFile = () => {
    setFile(null);
    setFileState(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileChange({ target: { name, files } });
    }
  };

  console.log("first2", file);

  return (
    <Box>
      {file && (
        <Box
          mb={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
            padding: "0.5rem",
            width: "33%",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {getFileIcon(file.name)}
            {file.name}
          </Typography>
          <IconButton
            onClick={handleDeleteFile}
            sx={{
              color: "white",
              backgroundColor: "rgba(0,0,0,0.7)",
              width: "20px",
              height: "20px",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.9)",
              },
              marginTop: "-25%",
              marginRight: "-12.5%",
            }}
          >
            <CloseIcon sx={{ fontSize: "10px" }} />
          </IconButton>
        </Box>
      )}

      <Box
        style={{
          border: "2px solid rgba(28, 72, 107, 1)",
          borderRadius: "6px",
          padding: "1rem",
          textAlign: "center",
          cursor: "pointer",
          width: "100%",
          marginTop: "1rem",
          backgroundColor: isDragOver ? "#f1f1f1" : "#fff",
        }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          type="file"
          hidden
          id={`upload-document-${name}`}
          name={name}
          accept=".csv,.xlsx"
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        <label htmlFor={`upload-document-${name}`}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <img src={uploadbutton} alt="Upload Icon" />
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Drop a file here or click to upload
            </p>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: "400",
                textAlign: "center",
                marginTop: "-10px",
                marginBottom: "-0.5rem",
              }}
            >
              Upload your file (CSV, XLSX max 5 MB)
            </p>
          </Box>
        </label>
      </Box>

      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default FileRead;
